
import { create } from 'zustand';
import { Toast } from './types';

type ToastState = {
  toasts: Toast[];
  addToast: (toast: Toast) => string;
  dismissToast: (id: string) => void;
  updateToast: (id: string, toast: Toast) => void;
};

// Generate a random ID for toasts
const generateId = () => Math.random().toString(36).substring(2, 9);

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  
  // Add a new toast
  addToast: (toast) => {
    const id = toast.id || generateId();
    
    set((state) => {
      // Remove duplicate toasts with the same ID
      const filteredToasts = state.toasts.filter((t) => t.id !== id);
      
      return {
        toasts: [
          ...filteredToasts,
          {
            ...toast,
            id,
            // Default duration is 5 seconds
            duration: toast.duration || 5000,
            // Default to dismissible
            dismissible: toast.dismissible !== false,
          },
        ],
      };
    });
    
    // Auto-dismiss after duration if not already dismissed
    const duration = toast.duration || 5000;
    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id),
        }));
      }, duration);
    }
    
    return id;
  },
  
  // Remove a toast by ID
  dismissToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },
  
  // Update a toast's properties
  updateToast: (id, toast) => {
    set((state) => ({
      toasts: state.toasts.map((t) =>
        t.id === id ? { ...t, ...toast } : t
      ),
    }));
  },
}));
